import { DropdownOption } from "@/types";

export const getOptionValue = (
  option: DropdownOption | string | number | null | undefined,
) => {
  if (option == null) {
    return option;
  }

  if (typeof option === "string" || typeof option === "number") {
    return option;
  }
  return option.value;
};
